var _style, _animate, _animate2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinAnimeted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .front {\n            fill: #3730a3;\n            opacity: 0.9;\n        }\n        #back {\n            fill: transparent;\n            stroke: #3730a3;\n            opacity: 0.7;\n        }\n    ")), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#back",
    attributeName: "r",
    from: 5.3,
    to: 10,
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite",
    fill: "freeze",
    id: "circ-anim"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#back",
    attributeType: "CSS",
    attributeName: "opacity",
    from: 1,
    to: 0,
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite",
    fill: "freeze",
    id: "circ-anim"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "back",
    cx: 10,
    cy: 10,
    r: 6.5,
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "front",
    cx: 10,
    cy: 10,
    r: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAnimeted);
export default __webpack_public_path__ + "static/media/pin-animeted.159c104f4604812776297a50bfe42c50.svg";
export { ForwardRef as ReactComponent };